export default {
  primary05: 'rgba(60, 123, 190, 0.05)',
  primary10: '#c4d7ed',
  primary25: '#f1f6fb',
  primary50: '#f4faf8',
  primary100: '#ebf2f9',
  primary200: '#8ab0da',
  primary300: '#77a2d3',
  primary400: '#3c7bbe',
  primaryButtonText: '#ffffff',
  primaryButtonTextInverted: '#3c7bbe',
  // https://angel-rs.github.io/css-color-filter-generator/
  primaryCalendarIconFilter:
    'brightness(0) saturate(100%) invert(43%) sepia(97%) saturate(386%) hue-rotate(170deg) brightness(85%) contrast(87%)',
  primaryShadowTilePrimary: '0 1px 0 2px rgba(60, 123, 190, 0.6)',
  secondary05: 'rgba(60, 123, 190, 0.05)',
  secondary100: '#fff8e6',
  secondary200: '#edd423',
  secondary300: '#f08e44',
  secondary400: '#ed8023',
  secondary500: '#ce6e1d',
  secondaryButtonText: '#ffffff',
  secondaryButtonTextInverted: '#2a5a8c',
  h1: '#3c7bbe',
  link: '#3c7bbe',
};

// orange: #ed8023
// blue: #3c7bbe
